import { copilotPanelWidth } from '@careerhub/common';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { BreakPoints } from '../../Constant';

export const useChatStyles = makeStyles({
  blade: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: copilotPanelWidth,
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    [BreakPoints.m]: {
      minWidth: '100%',
      overflowY: 'scroll',
    },
  },
});
